export const handleMembershipForm = function () {

    if ( !document.querySelector('.block-membership') ) { 
        return;
    }

    var forms = document.querySelectorAll('.needs-validation');

    Array.prototype.slice.call(forms)    
        
        .forEach(function (form) {
            form.addEventListener('submit', function (event) {

                if (!form.checkValidity() && !checkForXSSFields() ) {
                    event.preventDefault();
                    event.stopPropagation();
                }
 
                form.classList.add('was-validated');
        
            }, false);
    })


    function checkForXSSFields() {

        let retVal = false;

        let first_name = document.getElementById("first_name").value;
        let last_name = document.getElementById("last_name").value;
        let company = document.getElementById("company").value;

        if ( checkInputField( first_name, 'string') ) {
        
            retVal = true; 
             
        } else { 
        
            retVal = false;
            document.getElementById("first_name").value = '';
        }

        if ( checkInputField( last_name, 'string') ) { 
            
            retVal = true; 
        
        } else { 

            retVal = false;
            document.getElementById("last_name").value = ''; 
        
        }



        if ( checkInputField( company, 'string')   ) { 
        
            retVal = true; 
        
        } else { 

            retVal = false;
            document.getElementById("company").value = '';
        
        }

        return retVal;

    }

    // Ensure ReCaptcha has been checked
    const recaptcha_element = document.getElementById('krest_membership');
    
	if ( recaptcha_element ) {

		recaptcha_element.addEventListener("submit", function(evt) {

            $("#krest_membership_loader").show();
		
			var response = grecaptcha.getResponse();
				
			if( response.length == 0 ) { 

                $("#krest_membership_loader").hide();

                document.getElementById("chk_recaptcha_error").style.display = "block";

				evt.preventDefault();
				return false;
			}
  
		});

    }

    function checkInputField(string, type) {

        var regex;
    
        switch (type) {
    
            case "number":
                regex = /^[\d]+$/;
                break;
    
            case "string":
                regex = /^[^0-9*\\\^\/<>_#']+$/;
                break;
    
            case "email":
                regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,7})+$/;
                break;
        }
    
        if ( regex.test(string) ) {

             return true;

        } 

   
        return false;
    
    }

    
 
}
